import Aqua01 from './assets/screens/aqua/01-m.webp';
import AquaT01 from './assets/screens/aqua/t01-m.webp';
import Aqua02 from './assets/screens/aqua/02-d.webp';
import AquaT02 from './assets/screens/aqua/t02-d.webp';
import Aqua03 from './assets/screens/aqua/03-m.webp';
import AquaT03 from './assets/screens/aqua/t03-m.webp';
import Aqua04 from './assets/screens/aqua/04-m.webp';
import AquaT04 from './assets/screens/aqua/t04-m.webp';
import Aqua05 from './assets/screens/aqua/05-d.webp';
import AquaT05 from './assets/screens/aqua/t05-d.webp';
import CodexHotel01 from './assets/screens/codex-hotel/01-d.webp';
import CodexHotelT01 from './assets/screens/codex-hotel/t01-d.webp';
import CodexHotel02 from './assets/screens/codex-hotel/02-d.webp';
import CodexHotelT02 from './assets/screens/codex-hotel/t02-d.webp';
import CodexHotel03 from './assets/screens/codex-hotel/03-m.webp';
import CodexHotelT03 from './assets/screens/codex-hotel/t03-m.webp';
import CodexHotel04 from './assets/screens/codex-hotel/04-d.webp';
import CodexHotelT04 from './assets/screens/codex-hotel/t04-d.webp';
import CodexHotel05 from './assets/screens/codex-hotel/05-d.webp';
import CodexHotelT05 from './assets/screens/codex-hotel/t05-d.webp';
import CodexHotel06 from './assets/screens/codex-hotel/06-m.webp';
import CodexHotelT06 from './assets/screens/codex-hotel/t06-m.webp';
import CodexHotel07 from './assets/screens/codex-hotel/07-d.webp';
import CodexHotelT07 from './assets/screens/codex-hotel/t07-d.webp';
import CodexHotel08 from './assets/screens/codex-hotel/08-d.webp';
import CodexHotelT08 from './assets/screens/codex-hotel/t08-d.webp';
import CodexHotel09 from './assets/screens/codex-hotel/09-m.webp';
import CodexHotelT09 from './assets/screens/codex-hotel/t09-m.webp';
import Cravely01 from './assets/screens/cravely/01-d.webp';
import CravelyT01 from './assets/screens/cravely/t01-d.webp';
import Cravely02 from './assets/screens/cravely/02-m.webp';
import CravelyT02 from './assets/screens/cravely/t02-m.webp';
import Cravely03 from './assets/screens/cravely/03-d.webp';
import CravelyT03 from './assets/screens/cravely/t03-d.webp';
import Cravely04 from './assets/screens/cravely/04-m.webp';
import CravelyT04 from './assets/screens/cravely/t04-m.webp';
import Cravely05 from './assets/screens/cravely/05-d.webp';
import CravelyT05 from './assets/screens/cravely/t05-d.webp';
import Cravely06 from './assets/screens/cravely/06-d.webp';
import CravelyT06 from './assets/screens/cravely/t06-d.webp';
import Cravely07 from './assets/screens/cravely/07-m.webp';
import CravelyT07 from './assets/screens/cravely/t07-m.webp';
import ResultPortal01 from './assets/screens/result-portal/01-d.webp';
import ResultPortalT01 from './assets/screens/result-portal/t01-d.webp';
import ResultPortal02 from './assets/screens/result-portal/02-m.webp';
import ResultPortalT02 from './assets/screens/result-portal/t02-m.webp';
import ResultPortal03 from './assets/screens/result-portal/03-d.webp';
import ResultPortalT03 from './assets/screens/result-portal/t03-d.webp';
import ResultPortal04 from './assets/screens/result-portal/04-m.webp';
import ResultPortalT04 from './assets/screens/result-portal/t04-m.webp';
import ResultPortal05 from './assets/screens/result-portal/05-d.webp';
import ResultPortalT05 from './assets/screens/result-portal/t05-d.webp';
import TamalBeauty01 from './assets/screens/tamal-beauty/01-d.webp';
import TamalBeautyT01 from './assets/screens/tamal-beauty/t01-d.webp';
import TamalBeauty02 from './assets/screens/tamal-beauty/02-m.webp';
import TamalBeautyT02 from './assets/screens/tamal-beauty/t02-m.webp';
import TamalBeauty03 from './assets/screens/tamal-beauty/03-d.webp';
import TamalBeautyT03 from './assets/screens/tamal-beauty/t03-d.webp';
import TamalBeauty04 from './assets/screens/tamal-beauty/04-m.webp';
import TamalBeautyT04 from './assets/screens/tamal-beauty/t04-m.webp';
import TamalBeauty05 from './assets/screens/tamal-beauty/05-d.webp';
import TamalBeautyT05 from './assets/screens/tamal-beauty/t05-d.webp';
import TamalBeauty06 from './assets/screens/tamal-beauty/06-d.webp';
import TamalBeautyT06 from './assets/screens/tamal-beauty/t06-d.webp';
import TamalBeauty07 from './assets/screens/tamal-beauty/07-m.webp';
import TamalBeautyT07 from './assets/screens/tamal-beauty/t07-m.webp';
import TamalBeauty08 from './assets/screens/tamal-beauty/08-d.webp';
import TamalBeautyT08 from './assets/screens/tamal-beauty/t08-d.webp';
import AquaTabPTracker from './assets/screens/aqua/tp-tracker.webp';
import AquaTabPTrackerThumb from './assets/screens/aqua/th-tp-tracker.webp';
import CodexHotelTabLRooms from './assets/screens/codex-hotel/tl-rooms.webp';
import CodexHotelTabLRoomsThumb from './assets/screens/codex-hotel/th-tl-rooms.webp';
import CodexHotelTabPHome from './assets/screens/codex-hotel/tp-home.webp';
import CodexHotelTabPHomeThumb from './assets/screens/codex-hotel/th-tp-home.webp';
import CravelyTabLMenu from './assets/screens/cravely/tl-menu.webp';
import CravelyTabLMenuThumb from './assets/screens/cravely/th-tl-menu.webp';
import CravelyTabPHome from './assets/screens/cravely/tp-home.webp';
import CravelyTabPHomeThumb from './assets/screens/cravely/th-tp-home.webp';
import ResultPortalTabPSign_In from './assets/screens/result-portal/tp-sign_in.webp';
import ResultPortalTabPSign_InThumb from './assets/screens/result-portal/th-tp-sign_in.webp';
import TamalBeautyTabLHome from './assets/screens/tamal-beauty/tl-home.webp';
import TamalBeautyTabLHomeThumb from './assets/screens/tamal-beauty/th-tl-home.webp';
import TamalBeautyTabPServices from './assets/screens/tamal-beauty/tp-services.webp';
import TamalBeautyTabPServicesThumb from './assets/screens/tamal-beauty/th-tp-services.webp';

// Screens captured from each live project; d = desktop browser, m = phone
const screens = {
  'aqua': [
    { src: Aqua01, thumb: AquaT01, kind: 'phone', label: "Tracker" },
    { src: AquaTabPTracker, thumb: AquaTabPTrackerThumb, kind: 'tablet', label: "Tracker" },
    { src: Aqua02, thumb: AquaT02, kind: 'desktop', label: "Tracker" },
    { src: Aqua03, thumb: AquaT03, kind: 'phone', label: "Today's progress" },
    { src: Aqua04, thumb: AquaT04, kind: 'phone', label: "Today's log" },
    { src: Aqua05, thumb: AquaT05, kind: 'desktop', label: "Goal reached" },
  ],
  'codex-hotel': [
    { src: CodexHotel01, thumb: CodexHotelT01, kind: 'desktop', label: "Home" },
    { src: CodexHotelTabLRooms, thumb: CodexHotelTabLRoomsThumb, kind: 'tablet-wide', label: "Rooms" },
    { src: CodexHotel02, thumb: CodexHotelT02, kind: 'desktop', label: "Rooms & suites" },
    { src: CodexHotel03, thumb: CodexHotelT03, kind: 'phone', label: "Home" },
    { src: CodexHotel04, thumb: CodexHotelT04, kind: 'desktop', label: "Rooms" },
    { src: CodexHotelTabPHome, thumb: CodexHotelTabPHomeThumb, kind: 'tablet', label: "Home" },
    { src: CodexHotel05, thumb: CodexHotelT05, kind: 'desktop', label: "Deluxe room" },
    { src: CodexHotel06, thumb: CodexHotelT06, kind: 'phone', label: "Rooms" },
    { src: CodexHotel07, thumb: CodexHotelT07, kind: 'desktop', label: "Experiences" },
    { src: CodexHotel08, thumb: CodexHotelT08, kind: 'desktop', label: "Gallery" },
    { src: CodexHotel09, thumb: CodexHotelT09, kind: 'phone', label: "Sign in" },
  ],
  'cravely': [
    { src: Cravely01, thumb: CravelyT01, kind: 'desktop', label: "Home" },
    { src: CravelyTabLMenu, thumb: CravelyTabLMenuThumb, kind: 'tablet-wide', label: "Menu" },
    { src: Cravely02, thumb: CravelyT02, kind: 'phone', label: "Home" },
    { src: Cravely03, thumb: CravelyT03, kind: 'desktop', label: "Menu" },
    { src: Cravely04, thumb: CravelyT04, kind: 'phone', label: "Menu" },
    { src: CravelyTabPHome, thumb: CravelyTabPHomeThumb, kind: 'tablet', label: "Home" },
    { src: Cravely05, thumb: CravelyT05, kind: 'desktop', label: "Kitchen" },
    { src: Cravely06, thumb: CravelyT06, kind: 'desktop', label: "Sign up" },
    { src: Cravely07, thumb: CravelyT07, kind: 'phone', label: "Log in" },
  ],
  'result-portal': [
    { src: ResultPortal01, thumb: ResultPortalT01, kind: 'desktop', label: "Sign in" },
    { src: ResultPortalTabPSign_In, thumb: ResultPortalTabPSign_InThumb, kind: 'tablet', label: "Sign in" },
    { src: ResultPortal02, thumb: ResultPortalT02, kind: 'phone', label: "Sign in" },
    { src: ResultPortal03, thumb: ResultPortalT03, kind: 'desktop', label: "Create account" },
    { src: ResultPortal04, thumb: ResultPortalT04, kind: 'phone', label: "Create account" },
    { src: ResultPortal05, thumb: ResultPortalT05, kind: 'desktop', label: "Reset password" },
  ],
  'tamal-beauty': [
    { src: TamalBeauty01, thumb: TamalBeautyT01, kind: 'desktop', label: "Home" },
    { src: TamalBeautyTabLHome, thumb: TamalBeautyTabLHomeThumb, kind: 'tablet-wide', label: "Home" },
    { src: TamalBeauty02, thumb: TamalBeautyT02, kind: 'phone', label: "Home" },
    { src: TamalBeauty03, thumb: TamalBeautyT03, kind: 'desktop', label: "Services" },
    { src: TamalBeauty04, thumb: TamalBeautyT04, kind: 'phone', label: "Services" },
    { src: TamalBeautyTabPServices, thumb: TamalBeautyTabPServicesThumb, kind: 'tablet', label: "Services" },
    { src: TamalBeauty05, thumb: TamalBeautyT05, kind: 'desktop', label: "Gallery" },
    { src: TamalBeauty06, thumb: TamalBeautyT06, kind: 'desktop', label: "About" },
    { src: TamalBeauty07, thumb: TamalBeautyT07, kind: 'phone', label: "Testimonials" },
    { src: TamalBeauty08, thumb: TamalBeautyT08, kind: 'desktop', label: "Contact" },
  ],
};

export default screens;
